import { defineRecipe } from '@chakra-ui/react';

export const inputRecipe = defineRecipe({
	variants: {
		variant: {
			outline: {
				bg: 'white',
				borderWidth: '1px',
				borderColor: 'border',
				focusVisibleRing: 'inside',
				focusRingColor: 'var(--focus-color)',
			},
			subtle: {
				borderWidth: '1px',
				borderColor: 'transparent',
				bg: 'white',
				focusVisibleRing: 'inside',
				focusRingColor: 'var(--focus-color)',
			},
			flushed: {
				bg: 'transparent',
				borderBottomWidth: '1px',
				borderBottomColor: 'border',
				borderRadius: '0',
				px: '0',
				_focusVisible: {
					borderColor: 'var(--focus-color)',
					boxShadow: '0px 1px 0px 0px var(--focus-color)',
					_invalid: {
						borderColor: 'var(--error-color)',
						boxShadow: '0px 1px 0px 0px var(--error-color)',
					},
				},
			},
		},
	},
	defaultVariants: {
		variant: 'outline',
	},
});
